import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";

export const Loader: React.FC = () => {
  return (
    <Container>
      <Skeleton height={25} width={250} />
      <Description height={20} />
      <MapSkeleton height={280} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  text-align: center;
`;

const Description = styled(Skeleton)`
  width: 100%;
  max-width: 500px;
`;

const MapSkeleton = styled(Skeleton)`
  border-radius: 7px;
`;
